import React from 'react'; // eslint-disable-line

import { Typography, withStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import { ClaimType } from '../../claim/claim-types';
import { DeathClaim } from '../../claim/reducers/claim-reducers/death-claim-reducer';
import { State } from '../../redux/root-reducer';
import { GetFormSubmissionState, GetWorkflowState } from '../actions/navigate-to-next-screen';
import { WorkflowScreen } from '../reducers/workflow-screen';
import { WorkflowStep } from '../reducers/workflow-step';
import styles, { StyledComponent } from './styles';
import { WorkflowScreenView } from './workflow-screen';

type Props = StyledComponent & {
    screen: WorkflowScreen;
    getWorkflowState: GetWorkflowState;
    getFormSubmissionState: GetFormSubmissionState;
    includeIeb: boolean;
};

class WorkflowStepViewClass extends React.PureComponent<Props> {
    public render() {
        const { classes, screen, getWorkflowState, getFormSubmissionState } = this.props;
        const heading = getHeading(screen, this.props.includeIeb);
        return (
            <React.Fragment>
                <Typography variant="h5" className={classes.pageHeader}>
                    {screen?.screenHeading ? screen?.screenHeading : heading}
                </Typography>
                <WorkflowScreenView
                    workflowScreen={screen}
                    getWorkflowState={getWorkflowState}
                    getFormSubmissionState={getFormSubmissionState}
                />
            </React.Fragment>
        );
    }
}

export function getHeading(screen: WorkflowScreen, includeIeb: boolean) {
    const ancestors = [...screen.ancestors].reverse();
    if (screen instanceof WorkflowStep) {
        ancestors.push(screen);
    }

    const workflow = screen.ancestors[0];
    const iebWorkflowLabel = includeIeb && workflow?.label === 'Death' ? 'Death with IEB' : '';

    return ancestors
        .map(s => (s === workflow && iebWorkflowLabel ? iebWorkflowLabel : s.label))
        .filter(label => !!label)
        .join(' - ');
}

const mapStateToProps = (state: State) => {
    const claim = state.claimSession.claim as DeathClaim | undefined;
    return {
        includeIeb: claim?.claimType === ClaimType.Death && isIebIncluded(claim.includeIeb),
    };
};

export function isIebIncluded(value: string | null | undefined) {
    return value?.toLowerCase() === 'yes';
}

export const WorkflowStepView = connect(mapStateToProps)(withStyles(styles)(WorkflowStepViewClass));
